import { defineMessages } from 'react-intl';

export default defineMessages({
  accountNickname: {
    description: 'Carriers Table Account Nickname header label',
    defaultMessage: 'Account Nickname',
    id: 'AlLUxH',
  },
  primaryAccount: {
    description: 'Carriers Table Preferred Account header label',
    defaultMessage: 'Preferred Account',
    id: 'JvAU63',
  },
  services: {
    description: 'Carriers Table Services header label',
    defaultMessage: 'Services',
    id: 'XJderm',
  },
  actions: {
    description: 'Carriers Table Actions header label',
    defaultMessage: 'Actions',
    id: 'bO2lxc',
  },
  editSettings: {
    description: 'Carriers Table Edit Settings row cell label',
    defaultMessage: 'Edit Settings',
    id: 'zw+z7l',
  },
  setAsDefault: {
    description: 'Carriers Table Edit Settings dropdown item for setting an account as default use',
    defaultMessage: 'Set as Default',
    id: 'RiK+Kp',
  },
  carrierSettings: {
    description: 'Carriers Table Edit Settings dropdown item for carrier settings',
    defaultMessage: 'Carrier Settings',
    id: 'rpCu4D',
  },
  editNickname: {
    description: 'Carriers settings table edit nickname action',
    defaultMessage: 'Edit Nickname',
    id: 'S0tQVI',
  },
  emptyTable: {
    description: 'Carriers Table empty table CTA',
    defaultMessage: 'There are currently no carriers set up. Add one <a>here</a>.',
    id: 'PRR5MV',
  },
  delete: {
    description: 'Carrier Tables Delete Provider',
    defaultMessage: 'Delete Carrier',
    id: 'WkevQ7',
  },
  reconnect: {
    description: 'Reconnect OAuth Provider',
    defaultMessage: 'Reconnect',
    id: 'wKlw1Z',
  },
});
